import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { white } from "../../../theme/color.constants";

const Styled = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isReviewTab",
})(({ theme }) => ({
  "& .tabList": {
    "& .MuiTab-root": {
      marginRight: ".8rem",
      fontSize: ".75em",
      padding: "0.3125rem 0.625rem",
      borderRadius: "8px",
      maxHeight: "3.4375rem",
      minWidth: "6.25rem",
      flex: 1,
      backgroundColor: "rgb(75, 75, 75)",
      "&.Mui-selected": {
        backgroundColor: theme.palette.primary.dark,
        color: white,
        ...theme.applyStyles("light", {
          backgroundColor: theme.palette.primary.light,
        }),
      },
      "&.Mui-disabled": {
        color: "rgba(0, 0, 0, 0.38)",
        ...theme.applyStyles("dark", { color: "rgba(255, 255, 255, 0.5)" }),
      },
      "&.MuiTab-wrapped": { minWidth: "11.25rem" },
      ...theme.applyStyles("light", { backgroundColor: "#fff" }),
      ...theme.applyStyles("dark", { color: "rgba(255, 255, 255, 0.8)" }),
    },
    "& .MuiTabs-scrollButtons": {
      width: "1.875rem",
      transition: "width 0.3s ease-out",
      color: theme.palette.primary.dark,
      "& .MuiSvgIcon-root": { fontSize: "1.8rem" },
      "&.Mui-disabled": { width: 0 },
      [theme.breakpoints.down("sm")]: { width: "1.25rem" },
      ...theme.applyStyles("light", { color: theme.palette.primary.light }),
    },
  },

  "& .paper": {
    margin: "0.75rem 0",
    borderRadius: 0,
    borderTopColor: theme.palette.primary.dark,
    borderTopStyle: "solid",
    borderTopWidth: 4,
    marginBottom: "5rem",
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "12rem",
    },
    "& .recordWrapper": {
      margin: "0.3rem 1rem .8rem",
      borderRadius: "7px",
      [theme.breakpoints.down("sm")]: {
        margin: "0.3rem .7rem .8rem",
      },
    },
    "& .categoryTitle": {
      fontSize: "1.1rem",
      paddingLeft: ".6rem",
    },
    ...theme.applyStyles("light", {
      borderTopColor: theme.palette.primary.light,
    }),
  },

  "& #buttonContainer": {
    position: "absolute",
    margin: "2rem 0 1rem",
    "& .MuiButton-root": {
      margin: "0.5rem",
      minWidth: "auto",
    },
    "& .MuiButton-startIcon>*": {
      fontSize: "1.5625rem",
      marginRight: 0,
    },
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      "& .MuiButton-root": {
        margin: "0.5rem 0",
        minWidth: "100%",
      },
    },
  },
  "& .reviewTabBtnContainer": {
    margin: "2rem 0 0",
    "& .MuiButton-startIcon>*": {
      fontSize: "1.4375rem",
      marginRight: 0,
    },
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      "& .MuiButton-root": {
        margin: "0.5rem 0",
        minWidth: "100%",
      },
    },
  },

  variants: [
    {
      props: ({ isReviewTab }) => isReviewTab,
      style: {
        "& .paper": {
          [theme.breakpoints.down("sm")]: { marginBottom: undefined },
        },
      },
    },
  ],
}));

export default Styled;
